import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchResultComponent } from '@softapps/core';
import { I18nModule } from '@softline/ui-core';
import { KtostammKundeSubnummerListView } from '../list-view/ktostamm-kunde-subnummer.list-view';

@Component({
  selector: 'soft-search-result-view',
  imports: [CommonModule, I18nModule, KtostammKundeSubnummerListView],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KtostammKundeSubnummerFieldOkSearchResultViewComponent
  implements SearchResultComponent<any>
{
  readonly result = input.required<any>();
}
